module.exports = {
  
    stripePublishablecKey: "pk_live_51JVyVdJAWvES5KFNLafRgeE4o0CnUu3hCxavAH1LPhB117JHAXyiUFcHDULoAccJRLmVR0Sf01RzLiDmEjFhoTZk008BJFEmdg"   //Production Public Key
    //stripePublishableKey: "pk_test_51JVyVdJAWvES5KFNAcnfZUtEti3XDsu9n6xcYhxdnUyqNP5QWmuWyOkzcTdVj5fiL1Trv6SNa4sQwbFJneIGA9nW00bAMmVE1o"   //Test Public Key
};